<template>
  <div class="features">
    <section class="use-tachyon">
      <div class="tachyon-container use-tachyon-title">
        <h1>Use Tachyon <span>To Power Your Digital Platform</span></h1>
      </div>
      <big-data-scheme></big-data-scheme>
      <div class="tachyon-container section-logos">
        <div class="block-logos">
          <div class="snowflake-logo">
            <v-lazy-image src="/static/img/features_page/snowflake.png" src-placeholder="/static/img/placeholder.jpg" alt="snowflake"/>
          </div>
          <div>
            <v-lazy-image src="/static/img/features_page/ab_eau.png" src-placeholder="/static/img/placeholder.jpg" alt="ab eau"/>
          </div>
          <div>
            <v-lazy-image src="/static/img/features_page/looker.png" src-placeholder="/static/img/placeholder.jpg" alt="looker"/>
          </div>
        </div>
        <div class="block-logos">
         <div>
           <v-lazy-image src="/static/img/features_page/power_bi.png" src-placeholder="/static/img/placeholder.jpg" alt="power bi"/>
         </div>
         <div>
           <v-lazy-image src="/static/img/features_page/google_big_query.png" src-placeholder="/static/img/placeholder.jpg" alt="google big query"/>
         </div>
         <div>
           <v-lazy-image src="/static/img/features_page/amazon_s3.png" src-placeholder="/static/img/placeholder.jpg" alt="amazon s3"/>
         </div>
         <div class="data-logo">
           <v-lazy-image src="/static/img/features_page/345345.png" src-placeholder="/static/img/placeholder.jpg" alt="logo"/>
         </div>
       </div>
      </div>
      <advantages></advantages>
    </section>
    <why-tachyon></why-tachyon>
    <section class="bottom-section">
      <div class="tachyon-container contact-us-section">
        <div class="contact-us">
          <h3 class="blue-text">Get in touch, Experience the power of Tachyon for yourself</h3>
          <div class="info" itemscope itemtype="http://schema.org/PostalAddress">
            <div class="tel" itemprop="telephone">+44 (0)20 808 80034</div>
            <div>
              <a href="mailto:tachyon@1digit.co.uk" itemprop="email">tachyon@1digit.co.uk</a>
            </div>
            <div>
              <address class="address" itemprop="address">Kemp House, City Road, London, EC1V 2NX</address>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import BigDataScheme from '../components/Features/BigDataScheme.vue'
  import Advantages from '../components/Features/Advantages.vue'
  import WhyTachyon from '../components/Features/WhyTachyon.vue'

  export default {
    name: 'Features',
    components: {
      'big-data-scheme': BigDataScheme,
      'advantages': Advantages,
      'why-tachyon': WhyTachyon
    }
  }
</script>

<style scoped>
  .features {
    overflow: hidden;
  }
  .use-tachyon {
    position: relative;
    padding-top: 108px;
    padding-bottom: 64px;
    background: url('/static/img/features_page/top-bg.svg') 100% 0 no-repeat;
  }
  .use-tachyon-title h1 {
    font-family: 'RubicMedium', sans-serif;
    color: #fff;
    font-weight: 500;
    font-size: 80px;
    line-height: 81px;
  }
  .use-tachyon-title span {
    display: inline-block;
    font-family: 'RubicRegular', sans-serif;
    font-weight: 400;
    font-size: 27px;
    line-height: 29px;
    width: 210px;
  }
  .section-logos {
    display: flex;
  }
  .block-logos {
    width: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .block-logos > div {
    padding: 0 5px;
  }
  .snowflake-logo {
    margin-left: -5%;
  }
  .data-logo {
    margin-right: -4%;
  }
  .bottom-section {
    margin-top: -450px;
    padding-bottom: 150px;
    background: url('/static/img/features_page/bottom-bg.svg') no-repeat;
    background-size: cover;
  }
  .contact-us-section {
    padding-top: 540px;
  }
  .contact-us {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 60px 140px 70px 160px;
    background-color: #fff;
    box-shadow: 0 4px 34px rgba(0, 0, 0, 0.07);
    border-radius: 4px;
  }
  .contact-us h2 {
    font-family: 'RubicMedium', sans-serif;
    font-weight: 500;
    font-size: 62px;
    line-height: 73px;
    width: 500px;
  }
  .tel {
    font-family: 'RubicMedium', sans-serif;
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
  }
  .address {
    font-family: 'RubicRegular', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 20px;
    line-height: 24px;
  }
  .info {
    color: #000;
    width: 100%;
    max-width: 328px;
    border: 1px dashed #b9b9b9;
    box-sizing: border-box;
    border-radius: 4px;
  }
  .info > div {
    padding: 25px;
  }
  .info > div:not(:first-child) {
    border-top: 1px dashed #b9b9b9;
  }
  .info a {
    color: #1a68ff;
  }
  @media (min-width: 2000px) {
    .use-tachyon {
      background-size: 90%;
      background-position-y: 30%;
    }
  }
  @media (max-width: 1199px) {
    .snowflake-logo {
      margin-left: 0;
    }
    .data-logo {
      margin-right: 0;
    }
    .contact-us {
      padding-left: 70px;
      padding-right: 70px;
      justify-content: space-around;
    }
  }
  @media (max-width: 991px) {
    .use-tachyon {
      background: linear-gradient(357.59deg, #062745 0.62%, #170b22 99.38%);
    }
    .use-tachyon-title {
      text-align: center;
    }
    .use-tachyon-title h1 {
      line-height: 54px;
      margin-top: 30px;
      margin-bottom: 20px;
    }
    .use-tachyon-title span {
      width: 100%;
    }
    .section-logos {
      flex-direction: column;
    }
    .section-logos .block-logos:first-child {
      margin-bottom: 30px;
    }
    .block-logos {
      width: 100%;
    }
    .bottom-section {
      padding-bottom: 300px;
    }
    .contact-us {
      padding-left: 20px;
      padding-right: 20px;
    }
    .contact-us h2 {
      width: 100%;
      max-width: 380px;
      font-size: 52px;
      line-height: 62px;
    }
  }
  @media (max-width: 767px) {
    .use-tachyon {
      padding-bottom: 0;
    }
    .use-tachyon-title h1 {
      font-size: 70px;
    }
    .contact-us-section {
      padding-top: 500px;
    }
    .contact-us {
      width: 100%;
      max-width: 500px;
      margin: 0 auto;
      flex-direction: column;
    }
    .contact-us h2 {
      font-size: 42px;
      line-height: 52px;
      margin-bottom: 20px;
    }
    .info {
      max-width: 380px;
    }
  }
  @media (max-width: 479px) {
    .use-tachyon-title h1 {
      font-size: 33px;
      line-height: 34px;
      margin: 0;
    }
    .use-tachyon-title span {
      font-size: 15px;
      line-height: 16px;
    }
    .tachyon-container.section-logos {
      width: 95% !important;
    }
    .contact-us {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .contact-us h2 {
      font-size: 30px;
      line-height: 36px;
    }
    .info > div {
      padding-left: 15px;
      padding-right: 15px;
    }
    .tel {
      font-size: 25px;
      line-height: 30px;
    }
    .info > a {
      font-size: 18px;
      line-height: 21px;
    }
    .address {
      font-size: 18px;
      line-height: 21px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Features.vue